import { createContext } from 'react'
import { Map as MaplibreMap } from 'maplibre-gl'

export interface MapContextType {
  map: MaplibreMap | null
  mapLoaded: boolean
}

// NOTE:  The default value will be used only if useContext doesn't find a UserContext provider
//        up the component tree: https://reactjs.org/docs/context.html#reactcreatecontext
export const MapContext = createContext<MapContextType>({
  map: null,
  mapLoaded: false,
})
